export default class NotSignedInError extends Error {
  static CODE = 'not-signed-in'

  constructor(...args) {
    super(...args)
    this.code = NotSignedInError.CODE
  }
}
